import React from "react";
import { Link } from "react-router-dom";

const DashboardFooter = () => {
  return (
    <footer className="w-100 border-top mt-4 bg-light rounded mt-auto position-relative "   style={{
          background: "linear-gradient(135deg, #0564bf, #89CFF0",
          zIndex:999
        }}>
      <div className="container py-3 d-flex flex-column flex-md-row justify-content-center gap-2 align-items-center text-light small">
        
        <p className="mb-2 mb-md-0 text-center text-md-start">
          © {new Date().getFullYear()}{" "}
          <span className="fw-semibold text-light">Universal HRA</span>. All rights reserved.
        </p>

       
        <div className="d-flex gap-3">
          <Link to="/privacy-policy" className="text-light text-decoration-none hover-link">
            Privacy Policy
          </Link>
          <Link to="/conditions" className="text-light text-decoration-none hover-link">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
